import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "PH_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#PH_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#BF2714"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "PH_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#PH_svg__b)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0-2v14h32V-2H0z",
      fill: "#3D58DB"
    }
  )), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24l18-12L0 0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "PH_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 24
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24l18-12L0 0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement(
    "g",
    {
      mask: "url(#PH_svg__c)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FECA00"
    },
    /* @__PURE__ */ l.createElement("path", { d: "M13.606 10.92l1.276.492.759-.893.02 1.195 1.174.382-1.236.42.082 1.097-.815-.84-1.28.243.756-.969-.736-1.127zM1.606 16.92l1.172.519.863-.92-.083 1.221 1.277.356-1.34.446.185 1.071-.932-.765-1.161.168.652-.942-.633-1.154zM1.606 4.92l1.297.479.738-.88.042 1.181 1.152.396-1.214.406.06 1.111-.808-.806-1.286.209.777-.983-.758-1.113zM8.121 14.533a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" }),
    /* @__PURE__ */ l.createElement("path", { d: "M7.826 8.24l.134 1.605a.224.224 0 00.442.008l.178-1.6a.38.38 0 10-.754-.014zm-.418.775l.208.699c.02.065.084.105.157.092a.112.112 0 00.083-.135l-.165-.7a.158.158 0 00-.195-.117.13.13 0 00-.088.161zm1.123.728c-.016.06.02.121.085.14a.133.133 0 00.154-.089l.232-.69a.13.13 0 00-.098-.169.158.158 0 00-.183.113l-.19.695zm2.077-.702L9.49 10.275a.224.224 0 00.308.318l1.334-1.01a.381.381 0 10-.524-.543zm-.34 2.62l1.669-.13a.381.381 0 11-.013.755l-1.664-.183a.224.224 0 01.008-.442zm.866 2.659L9.838 13.19a.224.224 0 00-.318.308l1.072 1.345a.381.381 0 10.543-.524zm-2.683-.351l.099 1.684a.381.381 0 11-.754-.013l.212-1.68a.224.224 0 01.443.008zm-2.63.91l1.1-1.34a.224.224 0 00-.307-.318l-1.318 1.116a.381.381 0 10.524.543zm.324-2.726l-1.68.138a.381.381 0 11.014-.754l1.674.173a.224.224 0 01-.008.443zm-.996-2.63l1.424 1.1a.224.224 0 00.319-.307l-1.2-1.318a.381.381 0 10-.543.524zm4.19.416l.347-.64a.13.13 0 01.19-.044c.067.049.085.14.041.211l-.378.613a.112.112 0 01-.154.037.135.135 0 01-.046-.177zm1.758 1.17l-.7.207a.135.135 0 00-.091.157c.014.06.074.098.134.084l.701-.166a.158.158 0 00.116-.195.13.13 0 00-.16-.087zm-.923 1.931l.641.347a.13.13 0 01.043.19.158.158 0 01-.21.042l-.614-.38a.112.112 0 01-.036-.153.135.135 0 01.176-.046zM9.004 14.8l-.208-.699a.135.135 0 00-.157-.092.112.112 0 00-.083.134l.166.702a.158.158 0 00.195.115.13.13 0 00.087-.16zm-1.93-.923l-.348.64a.13.13 0 01-.19.044.158.158 0 01-.041-.212l.379-.612a.112.112 0 01.153-.037c.061.043.079.117.046.177zm-1.76-1.17l.699-.208a.135.135 0 00.092-.158.112.112 0 00-.135-.083l-.7.166a.158.158 0 00-.117.195.13.13 0 00.16.087zm.924-1.931l-.64-.348a.13.13 0 01-.044-.189.158.158 0 01.211-.042l.613.379a.112.112 0 01.036.154.135.135 0 01-.176.046zm3.728-.169c-.054.03-.072.099-.038.158.037.057.11.077.17.047l.653-.325a.13.13 0 00.05-.187.158.158 0 00-.21-.05l-.625.357zm.265 1.71c.018-.066.08-.1.14-.085l.694.19a.158.158 0 01.11.2.13.13 0 01-.165.081l-.69-.232a.133.133 0 01-.089-.154zm-.724 1.35c-.03-.053-.099-.072-.158-.038a.133.133 0 00-.046.171l.324.653a.13.13 0 00.188.05.158.158 0 00.05-.21l-.358-.626zm-1.71.265c.065.018.1.08.084.14l-.19.694a.158.158 0 01-.199.11.13.13 0 01-.081-.164l.231-.691a.133.133 0 01.154-.088zm-1.35-.723c.053-.031.072-.1.038-.159a.133.133 0 00-.172-.046l-.652.325a.13.13 0 00-.05.187c.046.069.138.09.21.05l.625-.357zm-.266-1.71c-.018.066-.08.1-.139.084l-.695-.19a.158.158 0 01-.109-.199.13.13 0 01.164-.081l.69.232a.133.133 0 01.089.153zm.724-1.35c.03.053.099.072.158.038a.133.133 0 00.047-.171l-.325-.653a.13.13 0 00-.188-.05.158.158 0 00-.049.21l.357.626z" })
  ))
), t = a;
export {
  t as default
};
